export default __webpack_public_path__ + "high-pressure-icon.png";